// extracted by mini-css-extract-plugin
export default {"header":"index_header_mGqZr clearfix","logo":"index_logo_N866W"};